import {
  TextField,
  CircularProgress,
  AutocompleteRenderInputParams,
} from "@mui/material";
import { FieldError } from "react-hook-form";

import "./SearchSelect.css";

const INPUT_COLOR_ERROR = "red";

type InputTextSearchSelectFetchProps = {
  params: AutocompleteRenderInputParams;
  isOpen: boolean;
  styles?: string;
  label: string;
  error: FieldError | undefined;
  loading: boolean;
  disabled?: boolean;
};

//TODO: Adding disabled before error is an incorrect implementation. We should find why is error being shown when clearing inputs
const InputTextSearchSelectFetch = ({
  params,
  isOpen,
  styles,
  label,
  error,
  loading,
  disabled = false,
}: InputTextSearchSelectFetchProps) => {
  return (
    <>
      <TextField
        className={styles}
        {...params}
        label={label}
        InputProps={{
          ...params.InputProps,
          startAdornment: isOpen ? (
            <img src="/images/Search.svg" alt="searchIcon" />
          ) : null,
          endAdornment: (
            <div id={"end"} style={{ display: "flex", alignItems: "center" }}>
              {loading ? <CircularProgress color="inherit" size={15} /> : null}
              {params.InputProps.endAdornment}
            </div>
          ),
        }}
      />
      {!disabled && error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {!disabled && error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR }}>
          Seleccionar opción válida*
        </span>
      )}
    </>
  );
};

export default InputTextSearchSelectFetch;
